import CodeSnippet from './CodeSnippet';

export default CodeSnippet;
